
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAllTodoList, todoItem, getTodoList } from '@/apis/todoList/todoList';
import TodoItem from '@/components/todoList/todoItem.vue';
import { CourseItem, getCourseList,getSimpleCourseList } from '@/apis/courseList/courseList';
import { Dialog, Toast } from 'vant'
import i18n from '@/lang';
Vue.use(Toast)

@Component({
  components: {
    TodoItem
  }
})
export default class TodoList extends Vue {
  public todoList: Array<any> = [];
  public isShowPopUp = false;
  public loadingVanOverlay = false;
  public allCourseList: Array<any> = [
    {
      id: '',
      classid: '',
      coursename: i18n.t('Home.全部课程')
    }
  ];
  public sourceName = i18n.t('Home.全部课程');
  public sourceNameTemporary = '';
  public sourceId = '';

  public pageConfig = {
    page: 1,
    limit: 10,
    type: "",
  };

  public scrollBusy:boolean = true;
  public totalSize = 0;
  public totalPage = 0;//总页数

  clickFilterCourse(){
    this.isShowPopUp = true
    // 获取班级列表
    if(this.allCourseList.length == 1){
      this.getCourseList();
    }
  }

  getAllTodoList(id?: string) {
    const params = {
      classid: id || '',
      ...this.pageConfig
    };
    this.loadingVanOverlay = true;
    getTodoList(params).then(res => {
      this.todoList = this.todoList.concat(res.list);
      this.loadingVanOverlay = false;
      this.totalPage = res.pageTotal;
      this.totalSize = parseInt(res.listTotal);
      this.$forceUpdate();
      if(this.totalSize > 0){
        this.scrollBusy = false;//允许滚动加载
      }
    });
  }

  //删除掉已经被比较成完成
  tagFinished(item:any){
    this.$toast('已被标记成完成');
    this.todoList = this.todoList.filter((todoItem:todoItem) => {
      return todoItem.id !== item.id;
    });
  }

  seletcterItemSelected(item: CourseItem) {
    this.sourceId = item.id;
    this.sourceNameTemporary = item.coursename;
  }
  getCourseList() {
    getSimpleCourseList()
      .then(res => {
        this.allCourseList = [...this.allCourseList, ...res.toplists, ...res.lists];
      })
      .catch(e => {
        console.log(e);
      });
  }
  cancelSelect() {
    this.sourceName = i18n.t('Home.全部课程');
    this.sourceId = '';
    this.todoList = [];
    this.getAllTodoList(this.sourceId);
    this.isShowPopUp = false;
  }
  confirmSelect() {
    this.todoList = [];
    this.sourceName = this.sourceNameTemporary;
    this.getAllTodoList(this.sourceId);
    this.isShowPopUp = false;
  }

  mounted () {
    this.todoList = [];
    this.getAllTodoList();
  }
  created() {
    this.todoList = [];
    this.$setNavInfo({ showBackIcon: false });
  }

  recordLoadMore(){
    this.scrollBusy = true;
    this.pageConfig.page++;
    if(this.pageConfig.page>this.totalPage){
      return;
    }
    const params = {
      classid: this.sourceId,
      ...this.pageConfig
    };
    getTodoList(params).then(res => {
      if(res.list.length > 0){
        this.scrollBusy = false;
        this.todoList = this.todoList.concat(res.list);
        this.$forceUpdate();
      }else{
        Toast(i18n.t('Home.已经全部加载完了没有更多了'));
      }
    });
  }
}
